export default "__VITE_ASSET__DxrlpVHY__"